// @flow

import type { StoreResourceDef } from 'app/core/types'

export const approvalWorkflows: StoreResourceDef<> = {
  resourceType: 'approvalWorkflows',
}
